import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

const $ = window.$;

class SalesReport extends Component {

    componentDidUpdate(prevProps, prevState) {

        // $('#sale-report').DataTable({
        //     searching: false,
        //     paginate: false,
        //     info: false,
        //     "footerCallback": function (row, data, start, end, display) {
        //         var api = this.api(),
        //             data;

        //         // Remove the formatting to get integer data for summation
        //         var intVal = function (i) {
        //             return typeof i === 'string' ?
        //                 i.replace(/[\฿,]/g, '') * 1 :
        //                 typeof i === 'number' ?
        //                     i : 0;
        //         };

        //         // Total over all pages
        //         var total = api
        //             .column(5)
        //             .data()
        //             .reduce(function (a, b) {
        //                 return intVal(a) + intVal(b);
        //             }, 0);

        //         // Total over this page
        //         var pageTotal = api
        //             .column(5, {
        //                 page: 'current'
        //             })
        //             .data()
        //             .reduce(function (a, b) {
        //                 return intVal(a) + intVal(b);
        //             }, 0);

        //         // Update footer
        //         $(api.column(5).footer()).html(
        //             pageTotal + ' ฿'
        //         );
        //     }
        // });
    }

    renderTable() {
        


    }

    render() {
        return (
            <div className="main-content">
                <div className="page-title">Sales Report</div>
                <div className="divider"></div>
                <div className="function sale-report">
                    <div className="row">
                        <div className="col-md-auto">
                            <div className="form-group dropdown sort-dropdown date-range">
                                <button className="btn dropdown-toggle sort-list date-range-list" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    10 Jul 2017 - 19 Jul 2017
                            </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <li>
                                        <a className="dropdown-item" href="#">20 Jul 2017 - 29 Jul 2017</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">30 Jul 2017 - 09 Aug 2017</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">19 Aug 2017 - 29 Aug 2017</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-auto">
                            <div className="form-group dropdown sort-dropdown product">
                                <button className="btn dropdown-toggle sort-list product-list" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    All Products
                            </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">Fish Oil</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-auto" style={{ width: '39.7%' }}></div>
                        <div className="col-md-auto">
                            <button className="btn button green-btn">Export</button>
                        </div>
                    </div>
                </div>
                <table id="sale-report" className="table table-list sales-report" cellSpacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Price/Unit</th>
                            <th>Amount</th>
                            <th>Sub Total</th>
                            <th>Discount</th>
                            <th>Grand Total</th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th>Total:</th>
                            <th colSpan="4">&nbsp</th>
                            <th className="price-column"></th>
                        </tr>
                    </tfoot>
                    <tbody>
                    {/* 
                        <tr>
                            <td>Me nutra - Fish Oil</td>
                            <td className="price-column">650.00 ฿</td>
                            <td>100</td>
                            <td className="price-column">65,000.00 ฿</td>
                            <td className="price-column">-15,000.00 ฿</td>
                            <td className="price-column">50,000.00 ฿</td>
                        </tr>
                        <tr>
                            <td>Me nutra - Sesame Oi</td>
                            <td className="price-column">650.00 ฿</td>
                            <td>100</td>
                            <td className="price-column">50,000.00 ฿</td>
                            <td className="price-column">-15,000.00 ฿</td>
                            <td className="price-column">320,800 ฿</td>
                        </tr>
                        <tr>
                            <td>Set Fish Oil</td>
                            <td className="price-column">1,650.00 ฿</td>
                            <td>50</td>
                            <td className="price-column">82,500.00 ฿</td>
                            <td className="price-column">-25,000.00 ฿</td>
                            <td className="price-column">57,500.00 ฿</td>
                        </tr>
                        <tr>
                            <td>Set Sesame Oil</td>
                            <td className="price-column">1,650.00 ฿</td>
                            <td>50</td>
                            <td className="price-column">82,500.00 ฿</td>
                            <td className="price-column">-25,000.00 ฿</td>
                            <td className="price-column">57,500.00 ฿</td>
                        </tr>
                        <tr>
                            <td>Family Set</td>
                            <td className="price-column">2,650.00 ฿</td>
                            <td>50</td>
                            <td className="price-column">132,500.00 ฿</td>
                            <td className="price-column">-32,500.00 ฿</td>
                            <td className="price-column">100,000.00 ฿</td>
                        </tr>
                    */}
                    </tbody>
                </table>

            </div>
        )
    }
}

export default SalesReport;


// WEBPACK FOOTER //
// ./src/views/sales-report/index.js